export default "__VITE_ASSET__CsRhomwC__"